import en from './en'
import fa from './fa'

export default {
  en,
  fa
}
